import { ArrowRight, ScrollText, BookMarked } from "lucide-react";
import { ArcButton } from "@/components/ArcButton";
import { Editable, EditableImage, ImageBlockZone } from "@/components/Editable";

export default function Home() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-14 sm:px-6 sm:py-20">
      <header className="text-center arc-fade-up">
        <Editable id="home.title" as="h1" fallback="THE ARCHIVES" className="font-serif-arc text-4xl font-black tracking-tight sm:text-5xl lg:text-6xl" />
        <Editable id="home.subtitle" as="p" fallback="An unnecessarily serious record of internet history." className="mt-4 text-base italic sm:text-lg" style={{ color: "var(--arc-text-2)" }} />
        <Editable id="home.intro" as="p" mode="multiline" fallback="Welcome to The Archives, a community-built collection documenting the people, projects, events, quotes, lore, and questionable historical decisions surrounding the Ghoulax and Zyfley communities." className="mx-auto mt-8 max-w-2xl text-base leading-relaxed" style={{ color: "var(--arc-text-2)" }} />
        <div className="mx-auto mt-8 max-w-3xl"><EditableImage id="home.hero" className="w-full rounded-md object-cover" label="hero image" alt="The Archives" /></div>
      </header>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2">
        {/* Ghoulax */}
        <article
          data-testid="home-card-ghoulax"
          className="group relative overflow-hidden rounded-md border-2 p-8 shadow-sm transition-shadow hover:shadow-lg arc-fade-up"
          style={{ backgroundColor: "var(--arc-card)", borderColor: "var(--ghoulax)" }}
        >
          <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-md" style={{ backgroundColor: "var(--ghoulax-soft)" }}>
            <ScrollText size={22} style={{ color: "var(--ghoulax)" }} />
          </div>
          <Editable id="home.ghoulax.title" as="h2" fallback="THE GLORIOUS GHOULAX ARCHIVES" className="font-serif-arc text-2xl font-black leading-snug" style={{ color: "var(--ghoulax)" }} />
          <Editable id="home.ghoulax.subtitle" as="p" fallback={'"An unbiased historical record. Obviously."'} className="mt-2 text-sm italic" style={{ color: "var(--arc-text-2)" }} />
          <Editable id="home.ghoulax.desc" as="p" mode="multiline" fallback="A prestigious and entirely impartial institution documenting the life, works, and legend of Ghoulax." className="mt-5 text-sm leading-relaxed" style={{ color: "var(--arc-text-2)" }} />
          <div className="mt-8">
            <ArcButton to="/ghoulax" variant="ghoulax" data-testid="enter-ghoulax-btn" className="w-full sm:w-auto">
              ENTER THE ARCHIVES <ArrowRight size={16} />
            </ArcButton>
          </div>
        </article>

        {/* Zyfley */}
        <article
          data-testid="home-card-zyfley"
          className="group relative overflow-hidden rounded-md border p-8 shadow-sm transition-shadow hover:shadow-lg arc-fade-up"
          style={{ backgroundColor: "var(--arc-card)", borderColor: "var(--zyfley)" }}
        >
          <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-md" style={{ backgroundColor: "var(--zyfley-soft)" }}>
            <BookMarked size={22} style={{ color: "var(--zyfley)" }} />
          </div>
          <Editable id="home.zyfley.title" as="h2" fallback="THE ZYFLEY ENCYCLOPEDIA" className="font-serif-arc text-2xl font-black leading-snug" style={{ color: "var(--zyfley)" }} />
          <Editable id="home.zyfley.subtitle" as="p" fallback={'"For completely objective historical research."'} className="mt-2 text-sm italic" style={{ color: "var(--arc-text-2)" }} />
          <Editable id="home.zyfley.desc" as="p" mode="multiline" fallback="A restrained, meticulously sourced encyclopedia dedicated to Zyfley and related historical events." className="mt-5 text-sm leading-relaxed" style={{ color: "var(--arc-text-2)" }} />
          <div className="mt-8">
            <ArcButton to="/zyfley" variant="zyfley" data-testid="open-zyfley-btn" className="w-full sm:w-auto">
              OPEN ENCYCLOPEDIA <ArrowRight size={16} />
            </ArcButton>
          </div>
        </article>
      </div>

      <ImageBlockZone id="home.blocks" className="mt-12" />

      <Editable id="home.tagline" as="p" fallback="Two encyclopedias. One universe. Zero accountability." className="mt-12 text-center text-xs italic" style={{ color: "var(--arc-text-2)" }} />
    </div>
  );
}
